import BaseService from './BaseService';

export interface CheckoutTrackingProps {
    user_id: string;
    store_id: string;
}

export default class TrackingService {
    baseService: BaseService;
    ApiBaseService: BaseService;
    constructor(orderType: string) {
        this.baseService = new BaseService(orderType);
        this.ApiBaseService = new BaseService('');
    }

    async checkoutTracking(params: CheckoutTrackingProps): Promise<any> {
        try {

            const { user_id, store_id } = params;

            const queryParams: Record<string, string | undefined> = {
                user_id: String(user_id),
                store_id: String(store_id),
            };

            const searchParams = new URLSearchParams(
                Object.entries(queryParams).filter(([, v]) => v !== undefined) as [string, string][]
            );

            const url = `checkout?${searchParams.toString()}`;
            const response = await this.baseService.http.get<{ params: CheckoutTrackingProps }>(url);
            return response.data;

        } catch (error: any) {
            console.error('Erro checkoutTracking:', error);
            throw error;
        }
    }

}